import { client } from '@/proxy/client'
import { gql } from 'graphql-request'
import { useMutation } from '@/proxy/react-query'

export const UPDATE_PII_SHARING = gql`
  mutation updatePocPiiSharing($input: UpdatePocPiiSharingInput!) {
    updatePocPiiSharing(input: $input) {
      success
      errors {
        category
        message
        target
        key
        args
      }
    }
  }
`

export const useUpdatePiiSharing = () =>
  useMutation({
    mutationFn: variables => client.request(UPDATE_PII_SHARING, variables),
  })
